import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchTechVisits({ serviceProviderId, currentPage = 1, rowsPerPage = 10, filters = {} }) {
    let url = `service_provider/tech_visits/query/list_tech_visits/${serviceProviderId}/fetch_tech_visits`;
    let query_string = `current_page=${currentPage}&&rows_per_page=${rowsPerPage}`;
    let filter_string = Object.keys(filters).filter(key => filters[key]).map(key => `${key}=${filters[key]}`).join('&&');
    if (filter_string) query_string = `${query_string}&&${filter_string}`;
    url = `${url}?${query_string}`;
    return RequesterV1.get(url);
  },

  fetchTechVisitForms(serviceProviderId) {
    let url = `service_provider/tech_visits/query/list_tech_visits/${serviceProviderId}/fetch_tech_visit_forms`;
    return RequesterV1.get(url);
  },

  fetchTechVisitInspectors(serviceProviderId) {
    let url = `service_provider/tech_visits/query/list_tech_visits/${serviceProviderId}/fetch_tech_visit_inspectors`;
    return RequesterV1.get(url);
  },

  fetchTechVisitCropFields(serviceProviderId) {
    let url = `service_provider/tech_visits/query/list_tech_visits/${serviceProviderId}/fetch_tech_visit_crop_fields`;
    return RequesterV1.get(url);
  }
};
